import { Text } from "@/components/ui/text";

interface FormErrorProps {
  message: string | undefined;
}

function FormError({ message }: FormErrorProps) {
  if (!message) return null;

  return (
    <div role="alert" className="rounded-sm bg-danger/10 px-3.5 py-2.5">
      <Text variant="small" className="text-danger">
        {message}
      </Text>
    </div>
  );
}

export { FormError };
